import {isNil} from 'lodash-es';

export class MachineGroup {
  private _name: string;
  private _imageId: number;
  private _parentGroupId: number;

  public constructor(name: string, imageId: number, parentGroupId: number) {
    this._name = name;
    this._imageId = imageId;
    this.parentGroupId = parentGroupId;
  }

  public get name(): string {
    return this._name;
  }

  public set name(name: string) {
    this._name = name;
  }

  public get parentGroupId(): number {
    return this._parentGroupId;
  }

  public set parentGroupId(parentGroupId: number) {
    this._parentGroupId = parentGroupId;
  }

  public get imageId(): number {
    return this._imageId;
  }

  public set imageId(imageId: number) {
    this._imageId = imageId;
  }

  public toJSON(): JSON {
    const machineGroupJSON = {
      name: this.name
    } as any as JSON;

    if (!isNil(this.parentGroupId)) {
      machineGroupJSON['parentGroupId'] = this.parentGroupId;
    }

    if (!isNil(this.imageId)) {
      machineGroupJSON['imageId'] = this.imageId;
    }

    return machineGroupJSON;
  }
}
